import { Grid } from '@mui/material';
import { CardGraphic } from '../CardGraphic';
import { useTranslation } from 'react-i18next';

import { ContainerGraphics } from './style';

export const GrahpsDeviationsProcess = ({
  containerViabilRef,
  containerExcavaRef,
  containerSasRef,
  containerSaesRef,
  chartRef,
  optionsGraphics,
  calculateChartWidth,
  calcDataGrahps,

  optionsDonut,
  donutTotalCategory,
}) => {

  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <ContainerGraphics ref={containerViabilRef}>
            <CardGraphic
              width={(containerViabilRef?.current?.clientWidth) && (calculateChartWidth('CJ54JOC6', calcDataGrahps) < containerViabilRef?.current?.clientWidth) ? '100%' : calculateChartWidth('CJ54JOC6', calcDataGrahps)}
              title={t("dashboard.graphics.deviations.viability")}
              type="bar"
              {...optionsGraphics('CJ54JOC6')}
              chartRef={chartRef}
            />
          </ContainerGraphics>
        </Grid>
        
        <Grid item xs={12} sm={6} md={4}>
          <ContainerGraphics width="100%" ref={containerSasRef}>
            <CardGraphic
              width={(containerSasRef?.current?.clientWidth) && (calculateChartWidth('VUJBZIKW', calcDataGrahps) < containerSasRef?.current?.clientWidth) ? '100%' : calculateChartWidth('VUJBZIKW', calcDataGrahps)}
              title={t("dashboard.graphics.deviations.sas")}
              type="bar"
              {...optionsGraphics('VUJBZIKW')}
              chartRef={chartRef}
            />
          </ContainerGraphics>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <ContainerGraphics ref={containerSaesRef}>
            <CardGraphic
              width={(containerSaesRef?.current?.clientWidth) && (calculateChartWidth('CB6KLBXD', calcDataGrahps) < containerSaesRef?.current?.clientWidth) ? '100%' : calculateChartWidth('CB6KLBXD', calcDataGrahps)}
              title={t("dashboard.graphics.deviations.saes")}
              type="bar"
              {...optionsGraphics('CB6KLBXD')}
              chartRef={chartRef}
            />
          </ContainerGraphics>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <ContainerGraphics ref={containerExcavaRef}>
            <CardGraphic
              width={(containerExcavaRef?.current?.clientWidth) && (calculateChartWidth('7V3B11QA', calcDataGrahps) < containerExcavaRef?.current?.clientWidth) ? '100%' : calculateChartWidth('7V3B11QA', calcDataGrahps)}
              title={t("dashboard.graphics.deviations.excavation")}
              type="bar"
              {...optionsGraphics('7V3B11QA')}
              chartRef={chartRef}
            />
          </ContainerGraphics>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <ContainerGraphics height='50%'>
              <CardGraphic
                type="donut"
                options={{
                  ...optionsDonut,
                  labels: donutTotalCategory.labels,
                  title: {
                    text: t("dashboard.graphics.deviations.topByDeviationsCount"),
                    align: 'center',
                  }
                }}
                chartRef={chartRef}
                series={donutTotalCategory?.series || []}
                height="100%"
              />
          </ContainerGraphics>
        </Grid>

      </Grid>

    </>
  )
}